// extracted by mini-css-extract-plugin
module.exports = {"productDiscount":"_1MVUcS8"};